import PropTypes from 'prop-types'
import React from 'react'
import withTranslation from 'next-translate/withTranslation'
import { Page, Page404 } from '../src/ui'
import {
  fetchCategory,
  setCurrentSubCategory,
} from '../src/modules/categories/actions'
import { UserAdsFilter } from '../src/modules/ads/filter/components'
import { getParsedFilterValues } from '../src/modules/ads/filter/functions'
import { fetchInfo, setInfo } from '../src/modules/users/detail/actions'
import { getInfo } from '../src/modules/users/detail/selectors'
import { AdsList } from '../src/modules/ads/list/components'
import { fetchAds } from '../src/modules/ads/list/actions'
import { adsTypes, globalOptions } from '../src/core/constants'
import { adsStatues } from '../src/modules/ads/shared/constants'
import { getCurrentSubCategory } from '../src/modules/categories/selectors'
import { getPaginationParams } from '../src/modules/ads/pagination/selectors'
import { CookiesHelper } from '../src/core/cookiesHelper/CookiesHelper'
import initialState from '../src/modules/redux/initialState'
import { deepCopy } from '../src/utils'
import { UserAdsPagination } from '../src/modules/ads/pagination/components'
import config from '../src/config/config.json'

class UserPage extends React.Component {
  static async getInitialProps ({store, query, req}) {
    let isPageExists = false
    let userInfo = null
    let categoryInfo
    let {username, userType, page = 1, category, ...restQuery} = query
    let filterValues = {}

    if (username) {
      if (category && category !== 'sve-kategorije') {
        await store.dispatch(fetchCategory({ seo: category, locale: query?.locale?.toUpperCase() || 'ME' }))
      }
      const userRequestParams = { username, locale: query?.locale?.toUpperCase() || 'ME' }
      await store.dispatch(fetchInfo(userRequestParams))
      const state = store.getState()
      userInfo = getInfo(state)
      if (category && category !== 'sve-kategorije') {
        categoryInfo = getCurrentSubCategory(state)
        if (categoryInfo) {
          isPageExists = true
        }
      } else {
        store.dispatch(setCurrentSubCategory(null))
      }
      if (userInfo) {
        const isMobileDevice = store.getState().common.isMobileDevice

        const limit = !isMobileDevice ? globalOptions.adsCountPerPage : globalOptions.adsCountPerPageMobile
        const type = adsTypes.all
        const status = adsStatues.PUBLISHED.code
        const sortBy = 'dateDesc'
        let adsRequestOptions = {...restQuery, page, type, limit, status, sortBy, adUser: userInfo.id}
        if (categoryInfo && categoryInfo.id) {
          adsRequestOptions.category = categoryInfo.id
        }
        const paginationParams = {
          ...getPaginationParams(state),
          currentPage: Number(page),
          adsType: type
        }

        const parsedFilterValues = getParsedFilterValues({ ...restQuery, locale: query?.locale?.toUpperCase() || 'ME' })

        filterValues = parsedFilterValues

        await store.dispatch(fetchAds({ ...adsRequestOptions, ...parsedFilterValues, locale: query?.locale?.toUpperCase() || 'ME' }, paginationParams))
        isPageExists = true
      }
    } else {
      store.dispatch(setCurrentSubCategory(null))
      store.dispatch(setInfo(null))
    }

    const userTypeName = userInfo && userInfo.type && userInfo.type.name
    const userName = userInfo && userInfo.name

    return {
      title: isPageExists
        ? `${userTypeName} - ${userName} | ${config.pages.defaultTitle}`
        : config.pages.notFoundTitle,
      isPageExists,
      filterValues,
      state: UserPage.getPageState(store, isPageExists)
    }
  }

  static getPageState (store, isPageExists = false) {
    const state = deepCopy(initialState)
    if (store) {
      const currentState = store.getState()

      state.user.auth.isAuthorized = currentState.user.auth.isAuthorized
      state.user.profile.error = currentState.user.profile.error
      state.user.profile.info = currentState.user.profile.info
      state.user.profile.favouriteAds = currentState.user.profile.favouriteAds
      state.user.profile.favouriteProfiles = currentState.user.profile.favouriteProfiles
      state.user.profile.priceTypes = currentState.user.profile.priceTypes
      state.user.detail.info = currentState.user.detail.info

      state.common.transitions = currentState.common.transitions
      state.common.router = currentState.common.router
      state.common.is404 = !isPageExists
      state.common.isMobileDevice = currentState.common.isMobileDevice
      state.common.userTypes = currentState.common.userTypes
      state.common.pageMetaTags = currentState.common.pageMetaTags
      state.common.pageMetaTagsSingle = currentState.common.pageMetaTagsSingle

      state.groups.elements = currentState.groups.elements

      state.categories.elements = currentState.categories.elements
      state.categories.bySeo = currentState.categories.bySeo
      state.categories.currentSubcategory = currentState.categories.currentSubcategory
      state.categories.sort = currentState.categories.sort
      state.categories.filters = currentState.categories.filters
      state.categories.activeCategories = currentState.categories.activeCategories

      state.ads.detail.reportTypes = currentState.ads.detail.reportTypes
      state.ads.detail.registrationFormulas = currentState.ads.detail.registrationFormulas

      state.form = currentState.form

      if (isPageExists) {
        state.ads.brands = currentState.ads.brands
        state.ads.equipment = currentState.ads.equipment
        state.ads.services = currentState.ads.services
        state.ads.list = currentState.ads.list
        state.ads.pagination = currentState.ads.pagination

        state.geoObjects.countries = currentState.geoObjects.countries
        state.geoObjects.cities = currentState.geoObjects.cities
      }
    }
    return state
  }

  render () {
    const { isPageExists, filterValues, i18n: { t } } = this.props

    return isPageExists
      ? <Page>
        <UserAdsFilter filterValues={filterValues} formStyle='default' />
        <AdsList
          noAdsMessage={t('common:noAdsMessage')}
          title=''
          isUserSearch
          filterValues={filterValues}
          formStyle='default'
        />
        <UserAdsPagination />
      </Page>
      : <Page404 />
  }
}

UserPage.propTypes = {
  isPageExists: PropTypes.bool.isRequired
}

UserPage.defaultProps = {
  isPageExists: false
}

export default withTranslation(UserPage)
